module.exports = __webpack_public_path__ + "static/media/ZEUSERP.a06481b1.svg";